export function maskStringNumber(value: string) {
  return value.replace(/\D/g, '');
}
